/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@environments/environment';
import { enableProdMode } from '@angular/core';

if (environment.isProduction) {
  enableProdMode();
  // Disable console.log() in prod
  window.console.log = () => {}
} else {
  // Chat disabled for not Production environment
  (window as any).Tawk_API = (window as any).Tawk_API || {};
  (window as any).Tawk_API.autoStart = false;
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error('Bootstrapping error', err));
